// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uWHs","tabsBox":"styles_tabsBox__T7VI1","createButton":"styles_createButton__LXTfP"};